var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StarRating',{attrs:{"increment":0.5,"show-rating":false,"rating":_vm.rating,"read-only":_vm.readOnly,"star-size":20},on:{"rating-selected":_vm.rateUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }